/*
 * Peelie countdown (custom, not part of Pitch).
 * Modes:
 *  - fixed: counts down to a wall-clock date/time ("2026-11-27 23:59").
 *    The time is read in the VISITOR'S local time zone, so the sale ends at
 *    23:59 in New York, 23:59 in London and 23:59 in Sydney alike.
 *  - daily: counts down to the next occurrence of a local time (default 24:00 = midnight)
 *    and restarts every day.
 * When a fixed timer runs out it hides itself. It never resets.
 */
(() => {
  if (customElements.get('peelie-countdown')) return;

  const pad = (n) => String(n).padStart(2, '0');

  const parseTime = (value, fallbackH, fallbackM) => {
    const m = /^(\d{1,2}):(\d{2})$/.exec((value || '').trim());
    return m ? [Number(m[1]), Number(m[2])] : [fallbackH, fallbackM];
  };

  class PeelieCountdown extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode;
      this.values = {};
      this.querySelectorAll('[data-unit]').forEach((el) => {
        this.values[el.dataset.unit] = el;
      });
      this.target = this.computeTarget();
      if (!this.target) return;
      this.tick = this.tick.bind(this);
      this.tick();
      this.interval = window.setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    computeTarget() {
      const now = new Date();
      if (this.mode === 'daily') {
        const [h, m] = parseTime(this.dataset.reset, 24, 0);
        const t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m, 0);
        if (t <= now) t.setDate(t.getDate() + 1);
        return t;
      }
      if (this.mode === 'fixed') {
        const m = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/.exec((this.dataset.end || '').trim());
        if (!m) return null;
        const h = m[4] !== undefined ? Number(m[4]) : 24;
        const min = m[5] !== undefined ? Number(m[5]) : 0;
        return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), h, min, 0);
      }
      return null;
    }

    tick() {
      let diff = this.target - new Date();
      if (diff <= 0) {
        if (this.mode === 'daily') {
          this.target = this.computeTarget();
          diff = this.target - new Date();
        } else {
          window.clearInterval(this.interval);
          this.hidden = true;
          this.dispatchEvent(new CustomEvent('peelie:countdown-ended', { bubbles: true }));
          return;
        }
      }
      const total = Math.floor(diff / 1000);
      const d = Math.floor(total / 86400);
      const h = Math.floor((total % 86400) / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;
      if (this.values.d) {
        this.values.d.closest('.peelie-countdown__unit').hidden = d === 0;
        this.values.d.textContent = pad(d);
      }
      if (this.values.h) this.values.h.textContent = pad(h);
      if (this.values.m) this.values.m.textContent = pad(m);
      if (this.values.s) this.values.s.textContent = pad(s);
      this.hidden = false;
    }
  }

  customElements.define('peelie-countdown', PeelieCountdown);
})();
